<template functional>
  <span
    v-bind="data.attrs"
    aria-hidden="true"
    :class="['Icon', data.class, data.staticClass]"
    v-on="listeners">
    <i :class="`i-${props.name}`">
      <template v-if="props.paths">
        <span
          v-for="(_, index) in new Array(props.paths).fill()"
          :key="index"
          :class="`path${index + 1}`" />
      </template>
    </i>
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    name: String,
    paths: Number,
  },
}
</script>

<style lang="scss">
@import '../../style/icons/style';

.Icon {
  position: relative;
}

[class^="i-"],
[class*=" i-"] {
  line-height: inherit;
}
</style>
